import { useState } from 'react'
import { apiFetch } from '../../api/core'

/**
 * «Забыли пароль?» на странице входа.
 *
 * Если у человека есть привязанный Telegram или настоящая почта — ссылка
 * приходит туда сразу, администратор не участвует. Если каналов связи нет
 * или логин не опознан — заявка уходит администратору, как раньше.
 *
 * Текст ответа одинаков во всех случаях и перечисляет оба исхода: сервер
 * намеренно не сообщает, существует ли такая учётная запись, иначе форму
 * можно использовать для перебора логинов сотрудников.
 */
export default function ForgotPasswordLink({ defaultLogin }) {
    const [open, setOpen] = useState(false)
    const [value, setValue] = useState('')
    const [note, setNote] = useState('')
    const [sending, setSending] = useState(false)
    const [done, setDone] = useState('')
    const [error, setError] = useState('')

    async function submit(e) {
        e.preventDefault()
        setError('')
        const target = (value || '').trim()
        if (!target) { setError('Укажите логин или почту'); return }
        setSending(true)
        try {
            const data = await apiFetch('/password-reset-requests', {
                method: 'POST',
                body: JSON.stringify({ login: target, note: note || null }),
            })
            // Текст берём с сервера: там он один на все исходы, и дублировать
            // его здесь — верный способ со временем разойтись с поведением.
            setDone(data?.message || 'Запрос принят.')
        } catch (e) {
            setError(e?.message || 'Не удалось отправить запрос. Напишите администратору напрямую.')
        } finally {
            setSending(false)
        }
    }

    if (done) {
        return (
            <p className='text-sm text-muted mt-16' style={{ textAlign: 'center' }}>
                {done}
            </p>
        )
    }

    if (!open) {
        return (
            <div className='mt-16' style={{ textAlign: 'center' }}>
                <button
                    type='button'
                    onClick={() => { setOpen(true); setValue(defaultLogin || '') }}
                    style={{ background: 'none', border: 'none', padding: 0, textDecoration: 'underline' }}
                    className='text-sm text-muted cursor-pointer'>
                    Забыли пароль?
                </button>
            </div>
        )
    }

    return (
        <form onSubmit={submit} className='mt-16'>
            <p className='text-sm text-muted' style={{ marginBottom: 10 }}>
                Пришлём ссылку для установки нового пароля в Telegram и на почту.
            </p>
            <input
                className='input' value={value} onChange={e => setValue(e.target.value)}
                placeholder='Логин или почта' style={{ width: '100%', marginBottom: 10 }} autoFocus
            />
            <input
                className='input' value={note} onChange={e => setNote(e.target.value)}
                placeholder='Комментарий (необязательно)' style={{ width: '100%', marginBottom: 10 }}
            />
            {error && <p className='text-sm' style={{ color: 'var(--color-danger)', marginBottom: 10 }}>{error}</p>}
            <div style={{ display: 'flex', gap: 8 }}>
                <button type='submit' className='btn btn--primary btn--sm' disabled={sending} style={{ flex: 1 }}>
                    {sending ? 'Отправляем…' : 'Прислать ссылку'}
                </button>
                <button type='button' className='btn btn--secondary btn--sm' onClick={() => setOpen(false)}>
                    Отмена
                </button>
            </div>
        </form>
    )
}
